import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import BestWrestler from '../../../pages/BestWrestler';
import BestFemaleWrestlerMobile from '../../../pages/Mobile/Stats/BestFemaleWrestlerMobile';

const BestFemaleWrestlerResposive = () => {
    const { isMobile } = useResponsiveRedux(); 
    return isMobile ? <BestFemaleWrestlerMobile /> : <BestWrestler isWoman={true} />;
}; 

export default BestFemaleWrestlerResposive;